export default `
mutation subProduto(
    $idProposta: String
    $subProdutoId: String
    $subProdutoDesc: String
    $tagEmMaos: Boolean
    $quantidadeIdentificadores: String
    $tipoProduto: String
    $comoUsar: String
    $captchaResponse: String
  ) {
    subProdutoFCG(
      payload: {
        id: $idProposta
        captchaResponse: $captchaResponse
        pedido: {
          comoUsar:$comoUsar
          produtos: [
            {
              subProdutoId:$subProdutoId
              subProdutoDesc: $subProdutoDesc
              tagEmMaos: $tagEmMaos
              tipoProduto: $tipoProduto
              quantidadeIdentificadores: $quantidadeIdentificadores
            }
          ]
        }
      }
    ) {
      dados {
        id
        situacaoProposta
        reprovadoAnaliseCredito
        planoPos
      }
      validatorResponse {
        errors {
          message
          category
        }
      }
    }
  }
`;
